import { css } from '@emotion/react';
import { black } from 'styles/global_defaults/colors';

const cardTextStyles = css`
  .card-text {
    font-size: 14px;
    line-height: 25px;
    color: ${black};
  }
`;

export default cardTextStyles;
